import React from 'react';
import { Wrapper } from '../Wrapper';
import { HeadAdvLogo } from '../HeadAdvLogo';
import styles from './HeroContainer.styles';

const HeroContainer = ({ propsHero: { homeSection, backgroundColor }, propsCommon: { logoHeadAdv }, children }) => (
  <div css={styles(backgroundColor)}>
    {homeSection ? (
      <div className="hero-background">
        <Wrapper maxWidth="1024px" width="100%" mobileWidth="100%">
          <div className="article__head">
            <div className="article__hero-wrapper">{children}</div>
          </div>
        </Wrapper>
        <div>
          <HeadAdvLogo logo={logoHeadAdv} sign="Supported by" />
        </div>
      </div>
    ) : (
      <>
        <div className="hero-background-logo" />
        <Wrapper maxWidth="1024px" width="100%" mobileWidth="100%">
          <div className="article__head">
            <div className="article__hero-wrapper">{children}</div>
          </div>
        </Wrapper>
      </>
    )}
  </div>
);

export default HeroContainer;
